module.exports = __webpack_public_path__ + "img/perfectiondetail.a34a605.webp";